import React, { ReactElement } from 'react';
import classNames from 'classnames';

type OnClickCallback = () => void;

interface LanguageSwitcherItemProps {
  elementClass?: String;
  // Href link of the item
  href?: string;
  // Text shown in dropdown ite,
  text: string;
  // Pass an element which represents dropdown item icon
  icon: JSX.Element;
  // Active status (highlighted)
  active?: boolean;
  onClick?: OnClickCallback;
}

enum ALLOWED_ELEMENT_CLASSES {
  LANGUAGE = 'language-dropdown',
  HOMEPAGE_SWITCHER = 'homepage-switcher'
}

const LanguageSwitcherItem: React.FC<LanguageSwitcherItemProps> = props => {
  const {
    elementClass,
    text,
    icon,
    active,
    onClick,
    href
  } = props;

  return (
    <div className={
      classNames({
        'homepage-switcher-item': elementClass === ALLOWED_ELEMENT_CLASSES.HOMEPAGE_SWITCHER,
        'language-dropdown-item': elementClass === ALLOWED_ELEMENT_CLASSES.LANGUAGE,
        'language-dropdown-item--hidden': active
      })
    }>
      <a className={
        classNames({
          'homepage-switcher-item__link': elementClass === ALLOWED_ELEMENT_CLASSES.HOMEPAGE_SWITCHER,
          'language-dropdown-item__link': elementClass === ALLOWED_ELEMENT_CLASSES.LANGUAGE,
          active })} href={href} onClick={onClick ? onClick : () => true}
         data-tracking="pro-dashboard-navbar__language">
        <span className={
          classNames({
            'homepage-switcher-item__icon': elementClass === ALLOWED_ELEMENT_CLASSES.HOMEPAGE_SWITCHER,
            'language-dropdown-item__icon': elementClass === ALLOWED_ELEMENT_CLASSES.LANGUAGE
          })}>
          {icon}
        </span>
        <span className={
          classNames({
          'homepage-switcher-item__title': elementClass === ALLOWED_ELEMENT_CLASSES.HOMEPAGE_SWITCHER,
          'language-dropdown-item__title': elementClass === ALLOWED_ELEMENT_CLASSES.LANGUAGE
        })}>
          {text}
        </span>
      </a>
    </div>
  );
};

export default LanguageSwitcherItem;
